module.exports = ".select-juste {\n    width: 50%;\n}\n\n.example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n\n.example-full-width {\n    width: 100%;\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/principal/interventions/write-intervention-modal/write-intervention-modal.component.css
// module id = ./src/app/principal/interventions/write-intervention-modal/write-intervention-modal.component.css
// module chunks = main